import { createFileRoute } from '@tanstack/react-router';
import TermsOfService from '../../components/terms-of-service/terms-of-service';
import { seo } from '../../utils/seo';

export const Route = createFileRoute('/_layout/legal/terms-of-service')({
  head: () => ({ meta: seo({ title: 'Általános Szerződési Feltételek' }) }),
  component: TermsOfServiceRoute
});

function TermsOfServiceRoute() {
  return (
    <div className="container-fluid">
      <div className="page-content centered">
        <h1 className="page-title">Általános Szerződési Feltételek</h1>
        <TermsOfService />
      </div>
    </div>
  );
}
